<template>
  <div>
    <div class="d-flex topbar">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item d-none d-sm-block">
            <router-link :to="{name: 'SearchList'}">Mes Recherches</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{name: 'SearchDetails', params: {id: searchId}}">Recherche</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{name: 'SearchQueries', params: {id: searchId}}">Requêtes</router-link>
          </li>
          <li class="breadcrumb-item active d-none d-md-block" aria-current="page">Ajouter une requête</li>
        </ol>
      </nav>
    </div>
    <div class="jumbotron">
      <h1>Ajouter/Modifier une requête liée à votre recherche</h1>
      <h4>
        En multipliant les requêtes concernant votre recherche, vous vous permettez plus d'options.
        <br />Par exemple, vous pouvez décidez d'allouer un budget de 500 000€ pour un appartement dans le 15ème arrondissement de Paris et seulement 400 000€ pour un même appartement répondant à vos critères dans le 14ème arrondissement.
      </h4>
    </div>

    <div class="container">
      <form>
        <div
          class="alert alert-danger"
          role="alert"
          v-bind:class="{ hide: status.errorMessage == null }"
        >{{status.errorMessage}}</div>

        <div class="form-group floating-label-form-group controls mb-0 pb-2">
          <label>Nom de la requête</label>
          <input
            type="text"
            class="form-control"
            v-model="queryName"
            aria-describedby="searchNameHelp"
            placeholder="Nom de la requête"
            disabled="disabled"
          />
          <small
            id="searchNameHelp"
            class="form-text text-muted"
          >Description de votre requête (par exemple: Paris 15ème, 3 pièces entre 40 et 60m² pour maximum 550 000€)</small>
        </div>

        <div style="margin-top: 40px;margin-bottom: 40px;">
          <div class="row">
            <div class="form-group col-md-3 text-left">
              <label>Nombre minimum de pièces</label>

              <select class="custom-select" v-model="multi.rooms">
                <option value="1">1+</option>
                <option value="2">2+</option>
                <option value="3">3+</option>
                <option value="4">4+</option>
                <option value="5">5+</option>
              </select>
            </div>

            <div class="form-group col-md-3 text-left">
              <label>Surface</label>
              <div class="row">
                <div class="col-6">
                  <input
                    type="number"
                    class="form-control"
                    v-model="multi.surface.minimum"
                    aria-describedby="surfaceMinimumHelp"
                    placeholder="Min Surface (m²)"
                  />
                  <small
                    id="surfaceMinimumHelp"
                    class="form-text text-muted text-center"
                  >Surface Minimum</small>
                </div>
                <div class="col-6">
                  <input
                    type="number"
                    class="form-control"
                    v-model="multi.surface.maximum"
                    aria-describedby="surfaceMaximumHelp"
                    placeholder="Max Surface (m²)"
                  />
                  <small
                    id="surfaceMaximumHelp"
                    class="form-text text-muted text-center"
                  >Surface Maximum (0 si pas de limite)</small>
                </div>
              </div>
            </div>

            <div class="form-group col-md-3 text-left">
              <label>Prix</label>
              <div class="row">
                <div class="col-6">
                  <input
                    type="number"
                    class="form-control"
                    v-model="multi.price.minimum"
                    aria-describedby="priceMinimumHelp"
                    placeholder="Min Price (€)"
                  />
                  <small id="priceMinimumHelp" class="form-text text-muted text-center">Prix Minimum</small>
                </div>
                <div class="col-6">
                  <input
                    type="number"
                    class="form-control"
                    v-model="multi.price.maximum"
                    aria-describedby="priceMaximumHelp"
                    placeholder="Max Price (€)"
                  />
                  <small
                    id="priceMaximumHelp"
                    class="form-text text-muted text-center"
                  >Prix Maximum (0 si pas de limite)</small>
                </div>
              </div>
            </div>

            <div class="form-group col-md-3">
              <label>Villes</label>
              <div class="row">
                <vue-tags-input
                  v-model="cityComplete"
                  :autocomplete-items="filteredItems"
                  :add-only-from-autocomplete="true"
                  :tags="multi.cities"
                  @tags-changed="newTags => multi.cities = newTags"
                />
              </div>

              <div class="row">
                  <label>Location ou achat ?</label>

                  <select class="custom-select" v-model="multi.sellingType">
                    <option value="Selling">Achat (ancien)</option>
                    <option value="SellingNew">Achat (neuf)</option>
                    <option value="Renting">Location</option>
                    <option value="Lifetime">Viager</option>
                  </select>
                </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-primary btn-xl btn-submit"
              @click="saveQuery()"
              v-show="!status.loading"
            >
              <span v-show="isCreation">Ajouter la requête</span>
              <span v-show="!isCreation">Mettre à jour la requête</span>
            </button>

            <div class="spinner-border text-primary" role="status" v-show="status.loading">
              <span class="sr-only">Mise à jour en cours...</span>
            </div>
            <!-- <button type="submit" @click="saveQuery()">Update Query</button> -->
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueTagsInput from "@johmun/vue-tags-input";
import jsonCities from "@/assets/cities.json"
// import { stringify } from '@angular/core/src/util';

export default {
  components: {
    VueTagsInput
  },
  name: "SearchQueryAdd",
  props: ["searchId", "queryId"],
  searchId: 0,
  queryId: 0,
  data() {
    return {
      sources: [],
      status: { loading: false, errorMessage: null },
      form: { externalSourceId: 0, queryName: "", jsonQuery: "", sourceId: 0 },
      cityComplete: "",
      multi: {
        sellingType: "",
        rooms: 0,
        surface: { minimum: 0, maximum: 0 },
        price: { minimum: 0, maximum: 0 },
        cities: []
      },
      availableCities: jsonCities
      // availableCities: [
      //   { text: "75 - Paris", value: "75000" },
      //   { text: "75001 - Paris", value: "75001" },
      //   { text: "75002 - Paris", value: "75002" },
      //   { text: "75003 - Paris", value: "75003" },
      //   { text: "75004 - Paris", value: "75004" },
      //   { text: "75005 - Paris", value: "75005" },
      //   { text: "75006 - Paris", value: "75006" },
      //   { text: "75007 - Paris", value: "75007" },
      //   { text: "75008 - Paris", value: "75008" },
      //   { text: "75009 - Paris", value: "75009" },
      //   { text: "75010 - Paris", value: "75010" },
      //   { text: "75011 - Paris", value: "75011" },
      //   { text: "75012 - Paris", value: "75012" },
      //   { text: "75013 - Paris", value: "75013" },
      //   { text: "75014 - Paris", value: "75014" },
      //   { text: "75015 - Paris", value: "75015" },
      //   { text: "75016 - Paris", value: "75016" },
      //   { text: "75017 - Paris", value: "75017" },
      //   { text: "75018 - Paris", value: "75018" },
      //   { text: "75019 - Paris", value: "75019" },
      //   { text: "75020 - Paris", value: "75020" },
      //   { text: "Evry", value: "91000" }
      // ]
    };
  },
  mounted() {
    var tempQueries = {};

    var vm = this;
    vm.searchId = this.$route.params.searchId;
    vm.queryId = this.$route.params.queryId;

    // axios
    //   .get(process.env.BACKEND_URL + "/api/searches/sources")
    //   .then(response => {
    //     vm.sources = response.data;
    //   });

    console.log("SearchID : " + vm.searchId);
    console.log("QueryID : " + vm.queryId);

    if (vm.queryId != null && vm.queryId != 0) {
      axios
        .get(
          process.env.BACKEND_URL +
            "/api/searches/" +
            vm.searchId +
            "/queries/" +
            vm.queryId
        )
        .then(response => {
          vm.form = {
            queryName: response.data.queryName
          };

          console.log("jsonQuery : ");
          console.log(JSON.parse(response.data.jsonQuery));
          vm.multi = JSON.parse(response.data.jsonQuery);
        });
    }
  },
  computed: {
    filteredItems() {
      return this.availableCities.filter(i => {
        return (
          i.text.toLowerCase().indexOf(this.cityComplete.toLowerCase()) !== -1
        );
      });
    },
    queryName(){
      console.log(this.multi.cities);
      var searchName = this.multi.cities.map(city => city.value).join(',') + " - ";
      searchName += this.multi.rooms + "+ pièces, ";
      if(this.multi.surface.minimum != 0 || this.multi.surface.maximum != 0){
        if(this.multi.surface.maximum == 0)
          searchName += "minimum " + this.multi.surface.minimum + "m², ";
        else if(this.multi.surface.minimum == 0)
          searchName += "maximum " + this.multi.surface.maximum + "m², ";
        else
          searchName += this.multi.surface.minimum + " à " + this.multi.surface.maximum + "m², ";
      }
      if(this.multi.price.minimum != 0 || this.multi.price.maximum != 0){
        if(this.multi.price.maximum == 0)
          searchName += "minimum " + this.multi.price.minimum + "€";
        else if(this.multi.price.minimum == 0)
          searchName += "maximum " + this.multi.price.maximum + "€";
        else
          searchName += this.multi.price.minimum + "€ à " + this.multi.price.maximum + "€";
      }

      this.form.queryName = searchName;
      return searchName;
    },
    isCreation() {
      if (this.queryId != null && this.queryId != 0) return false;
      return true;
    }
  },
  methods: {
    saveQuery: function() {
      var vm = this;
      
      vm.status.loading = true;
      var queryModel = {};

      queryModel.sourceId = vm.form.sourceId;
      queryModel.queryName = vm.form.queryName;

      queryModel.jsonQuery = JSON.stringify(vm.multi);

      var url =
        process.env.BACKEND_URL + "/api/searches/" + vm.searchId + "/queries";
      if (vm.queryId != null && vm.queryId != 0) {
        // Update
        url += "/" + vm.queryId;

        axios.put(url, queryModel).then(response => {
          vm.$router.push({
            name: "SearchDetails",
            params: { id: vm.searchId }
          });
          return false;
        }).catch(error => {
          if(error.response){
            if(error.response.status == 500)
              vm.status.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
          } else
            vm.status.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.loading = false;
        });
      } else {
        axios.post(url, queryModel).then(response => {
          vm.$router.push({
            name: "SearchDetails",
            params: { id: vm.searchId }
          });
          return false;
        }).catch(error => {
          if(error.response){
            if(error.response.status == 500)
              vm.status.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
          } else
            vm.status.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.loading = false;
        });
      }

      return false;
    }
  }
};
</script>

<style scope>

.vue-tags-input {
  width: 100%;
  max-width: 100%;
}

.ti-input {
  border: 0.125rem solid #ced4da;
  border-radius: 0.5rem;
  width: 100%;
}

.ti-tag {
  background-color: #2c3e50 !important;
}

.search-items {
}

.search-items .search-item {
  margin-bottom: 10px;
}

.search-items .search-item .search-item-picture {
  max-height: 150px;
}

.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/queries/SearchQueryAdd.vue